/* eslint-disable @typescript-eslint/no-namespace */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalDialog from '@ui/modal/ModalDialog';
import useBreakpoint from '@utils/useBreakpoint';
import ContactDetailsCore from '../clientService/ContactDetailsCore';
const ContactDetailsAlternate = () => {
    var _a;
    const { t } = useTranslation();
    const [showEnhanceModal, setShowEnhanceModal] = useState(false);
    const currentBreakpoint = useBreakpoint();
    const isMobile = currentBreakpoint < 1024;
    const isTabletOrDesktop = currentBreakpoint >= 1024;
    const queryOrderDetail = (_a = new URLSearchParams(location.search)) === null || _a === void 0 ? void 0 : _a.get('orderId');
    const url = window.location.pathname;
    const isReturnOrExchage = url.includes('newreturn') || url.includes('newexchange');
    return (React.createElement(React.Fragment, null,
        (!queryOrderDetail || isReturnOrExchage) && (React.createElement("div", { className: "container contact-details__alternate" },
            React.createElement("div", { className: "contact-details__column" },
                React.createElement("h2", { className: "contact-details__title" }, isMobile ? t('clientservice.contactsdetails.git') : t('clientservice.contactus')),
                isTabletOrDesktop && React.createElement(ContactDetailsCore, { type: "LIST", hideCountrySelector: !isTabletOrDesktop, postponeCountrySelector: true })),
            React.createElement("div", null, !isTabletOrDesktop && (React.createElement("button", { className: "button button--secondary contact-details__modal-btn", onClick: (e) => {
                    e.preventDefault();
                    setShowEnhanceModal(true);
                } }, t('clientservice.contactus')))))),
        !isTabletOrDesktop && (React.createElement(ModalDialog, { className: "client-service__modal--enhanced", isOpen: showEnhanceModal, role: "dialog", onRequestClose: () => {
                setShowEnhanceModal(false);
            } },
            React.createElement("div", { className: "contact-details--enhanced" },
                React.createElement("div", { className: "contact-details contact-details--modal" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "row justify-center" },
                            React.createElement("div", { className: "col-lg-6 col-md-8 col-sm-10" },
                                React.createElement("h2", { className: "contact-details__title primary-l-u" }, t('contactus.contactform')),
                                React.createElement("p", { className: "contact-details__description primary-m" }, t('contactus.intro')),
                                React.createElement(ContactDetailsCore, { type: "BLOCKS", hideCountrySelector: !isTabletOrDesktop }))))))))));
};
export default ContactDetailsAlternate;
